<ng-template  
#template 
cdkConnectedOverlay 
cdkConnectedOverlayPush 
[cdkConnectedOverlayPositions]="positionPairs" [cdkConnectedOverlayOrigin]="trigger" 
[cdkConnectedOverlayOpen]="openMenu"
[cdkConnectedOverlayHasBackdrop]="true" 
(detach)="closeMenu.emit()" 
(backdropClick)="closeMenu.emit()">
  <div class="menu-content">
    <span class="menu-item" *ngFor="let item of items">
      <button  [ngStyle]="{ 'background-color': btnColorValidation() }"  *ngIf="item.hasPermission" class="button-item" mat-menu-item (click)="item.link ? (item.externalOpening ? goExternal(item.link) : goTo(item.link)) : ''">
        <span [ngStyle]="{ color: fontColorValidation() }">{{ item.link_name }}</span>
      </button>
    </span>
  </div>
</ng-template>